(() => {
  if (customElements.get('fp-home-carousel')) return;
  customElements.define('fp-home-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-hero-go]')];
      this.pauseButton = this.querySelector('[data-hero-pause]');
      this.status = this.querySelector('[data-hero-status]');
      this.index = 0;
      this.userPaused = false;
      this.focusPaused = false;
      this.hoverPaused = false;
      this.inView = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.schedule(), { signal });
      this.dots.forEach(button => button.addEventListener('click', () => {
        this.show(Number(button.dataset.heroGo), true);
      }, { signal }));
      this.querySelector('[data-hero-prev]').addEventListener('click', () => this.show(this.index - 1, true), { signal });
      this.querySelector('[data-hero-next]').addEventListener('click', () => this.show(this.index + 1, true), { signal });
      this.pauseButton.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.schedule();
      }, { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') {
          this.hoverPaused = true;
          this.schedule();
        }
      }, { signal });
      this.addEventListener('pointerleave', () => {
        this.hoverPaused = false;
        this.schedule();
      }, { signal });
      this.addEventListener('focusin', () => {
        this.focusPaused = true;
        this.schedule();
      }, { signal });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {
          this.focusPaused = false;
          this.schedule();
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        this.dots[this.index].focus({ preventScroll: true });
      }, { signal });
      this.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || event.target.closest('a,button')) return;
        this.touch = { x: event.clientX, y: event.clientY };
      }, { signal });
      this.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.show(this.index + (dx < 0 ? 1 : -1), true);
        }
      }, { signal });
      this.addEventListener('pointercancel', () => { this.touch = null; }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.classList.add('is-ready');
      this.show(0);
    }

    show(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      if (manual) this.status.textContent = this.index === 0
        ? 'Slide 1 of 2: Tribute to Geometry'
        : 'Slide 2 of 2: New long-sleeve collection';
      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.timer);
      const reduced = this.motion.matches;
      this.pauseButton.hidden = reduced;
      this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play banner rotation' : 'Pause banner rotation');
      this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
      this.pauseButton.querySelector('[data-pause-icon]').hidden = this.userPaused;
      this.pauseButton.querySelector('[data-play-icon]').hidden = !this.userPaused;
      if (this.userPaused || this.focusPaused || this.hoverPaused || reduced || !this.inView || document.hidden) return;
      this.timer = window.setTimeout(() => this.show(this.index + 1), 7000);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
